import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Общий индикатор генерации Менар: счётные столбики в палитре игровых кнопок. */
@Component({
  selector: 'ms-generation-loader',
  standalone: true,
  template: `
    <div class="loader" role="status" aria-live="polite">
      <div class="loader__counting" aria-hidden="true">
        <span></span><span></span><span></span><span></span>
      </div>
      <div class="loader__label"><ng-content /></div>
    </div>
  `,
  styleUrl: './generation-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerationLoaderComponent {}
